// const obj = {
//     AppName:"Musify",
//     AppDesc:"Fell And Hell"
// }

// export  default obj;

// export const  AppName="Musify";
export const  AppName="Music Hunt";
export const  AppDesc="Fell And Hell";
export const NAPSTER_APP_ID ="faf861a2-e3e4-4cd6-a972-e23d64faa5c9";
export  const NAPSTER_API_KEY ="NzE5MDJlNmQtZjllMy00YTA3LWEwM2MtY2IxMDI4NDVhY2Q0";
export const NAPSTER_API_SECRET ="NzA5NzNjMzctM2ZjZS00NjcyLWI2NDMtYTA4N2U0ODBiNTFh";


export const SET_PLAY_NOW = "SET_PLAY_NOW";
export const MAKE_FAVOURITE = "MAKE_FAVOURITE"
export const REMOVE_FAVOURITE = "REMOVE_FAVOURITE"
export const ADD_TO_PLAYLIST = "ADD_TO_PLAYLIST"
export const REMOVE_FROM_PLAYLIST = "REMOVE_FROM_PLAYLIST"
export const PLAY_NEXT_SONG = "PLAY_NEXT_SONG"
export const PLAY_PREV_SONG = "PLAY_PREV_SONG"
export const REPLACE_PLAYLIST = "REPLACE_PLAYLIST"
